const infoContainer = document.querySelector('.js-photo-extra-info');
const button = document.querySelector('.js-photo-info-toggle');

const toggleInfoContainer = () => {
  infoContainer.classList.toggle('slide-down');
};

button.addEventListener('click', toggleInfoContainer);
